import React from "react";
import Table from "react-bootstrap/Table";
import { headerStyle } from "../../../../assets/css/customStyle";

const SettleupsTable = ({ settleupsData = [] }) => {
  const formatAmount = (amount) => {
    if (amount === null || amount === undefined) return "";
    const num = typeof amount === "number" ? amount : Number(amount);
    if (Number.isFinite(num)) return num.toFixed(2);
    return String(amount);
  };

  return (
    <div className="react-event-table-class">
      <Table bordered hover responsive className="mb-0">
        <thead>
          <tr>
            <th style={{ width: "10%", ...headerStyle }}>Sr no</th>
            <th style={{ width: "30%", ...headerStyle }}>Owing User</th>
            <th style={{ width: "30%", ...headerStyle }}>Owed User</th>
            <th style={{ ...headerStyle }}>Amount</th>
            <th style={{ width: "15%", ...headerStyle }}>Is Settled</th>
          </tr>
        </thead>
        <tbody>
          {settleupsData.length > 0 ? (
            settleupsData.map((row, idx) => (
              <tr key={row.id ?? idx} className="table-bg-col">
                <td>{idx + 1}</td>
                <td>{row.user_owing_name}</td>
                <td>{row.user_owed_name}</td>
                <td>
                  <div className="text-success">
                    +{formatAmount(row.amount)} {row.currency_type || ""}
                  </div>
                </td>
                <td>{row.is_settled ? "true" : "false"}</td>
              </tr>
            ))
          ) : (
            <tr className="table-bg-col">
              <td colSpan={5} className="text-center">
                No settleups found!
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default SettleupsTable;


